export default __webpack_public_path__ + "static/media/SF Compact Display Regular.62035240.ttf";